import { Component } from '@angular/core';

import {
  AdvancedFilterModel,
  IFilterParams,
  JoinAdvancedFilterModel,
  NumberAdvancedFilterModel,
} from 'ag-grid-enterprise';

import { InputChoicesComponent } from '@camelot/form-input';
import { TranslatePipe } from '@camelot/translation';
import { TextComponent } from '@camelot/ui';

import { ActiveFilterTag } from '../../../../filters/types';
import { BaseFilterComponent } from '../base-col';
import type { EnumCol } from './enum-col';

@Component({
  host: { 'data-cid': 'enum-filter' },
  imports: [InputChoicesComponent, TextComponent, TranslatePipe],
  styleUrls: ['../filter.scss'],
  template: `
    @if (this.input) {
      <div>
        <div class="filter-title">
          <cam-text [isBold]="true" size="sm" color="brand-primary">{{ this.filterTitle() | translate }}</cam-text>
        </div>
        <div class="p-space-sm">
          <cam-input-choices
            [input]="$any(this.input)"
            [standalone]="true"
            (valueChanged)="this.applyInputValue($event)"
          ></cam-input-choices>
        </div>
      </div>
    }
  `,
})
export class EnumFilterComponent extends BaseFilterComponent<
  JoinAdvancedFilterModel | NumberAdvancedFilterModel,
  EnumCol
> {
  override agInit(params: IFilterParams) {
    super.agInit(params);
  }

  override getTags(model?: AdvancedFilterModel | null): ActiveFilterTag[] {
    if (!model) {
      model = this._model;
    }
    if (!model) {
      return [];
    }
    if (model.filterType === 'number') {
      if (model.filter === undefined) {
        return [];
      }
      const value = this._col?.getEnumInfo().values.find(v => v.id == (<any>model).filter?.toString())?.name;

      if (!value) {
        return [];
      }
      return [
        {
          condition: model,
          id: model.colId,
          name: value,
        },
      ];
    }
    if (model.filterType === 'join') {
      return model.conditions.flatMap(condition => this.getTags(condition));
    }

    return [];
  }
}
